
/**
 * SEO 配置 - models (Português)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - Gerador de vídeo IA principal | WeryAI',
        description: 'Google Veo 3.1: Modelo de vídeo IA principal com áudio nativo e controle de quadros.',
        keywords: 'Google Veo 3.1, vídeo IA, gerador de vídeo, WeryAI',
    },
    veo_3: {
        title: 'Google Veo 3 Geração de vídeo IA de alta qualidade | WeryAI',
        description: 'Experimente Veo 3 no WeryAI. Resultados de alta qualidade.',
        keywords: 'Veo 3, Google Veo, vídeo IA, WeryAI',
    },
    veo_3_fast: {
        title: 'Google Veo 3 Fast Geração de vídeo IA ultrarrápida | WeryAI',
        description: 'Experimente Veo 3 Fast no WeryAI. Resultados rápidos e de alta qualidade.',
        keywords: 'Veo 3 Fast, vídeo IA rápido, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 - Gerador de vídeo IA realista | WeryAI',
        description: 'Experimente Sora 2 no WeryAI. Resultados de alta qualidade.',
        keywords: 'Sora 2, OpenAI Sora, vídeo IA, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 - Gerador de vídeo IA | WeryAI',
        description: 'Experimente WeryAI Video 1.0 para criar vídeos IA cinematográficos.',
        keywords: 'WeryAI Video 1.0, vídeo IA, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2 - Gerador de Imagens IA Nativo | WeryAI',
        description: 'Use WeryAI Image 2 para geração nativa impressionante de imagens IA! Modelo principal com controle de estilo avançado. Créditos grátis, sem cartão.',
        keywords: 'WeryAI Image 2, gerador de imagens IA nativo, imagem IA principal, qualidade estúdio IA, WeryAI Image grátis, como usar WeryAI Image 2, WeryAI',
    },
    image_grok_2: {
        title: 'Grátis Grok 2 - Gerador de Imagens xAI | WeryAI',
        description: 'Use Grok 2 no WeryAI para gerar imagens IA criativas! Modelo xAI com flexibilidade artística e estilos visuais únicos. Créditos grátis, sem cartão.',
        keywords: 'Grok 2, Grok AI, gerador de imagens xAI, arte IA, imagens IA criativas, Grok 2 grátis, como usar Grok 2, WeryAI',
    },
    image_nano_banana_2: {
        title: 'Nano Banana 2 Gerador de Imagens | WeryAI',
        description: 'Nano Banana 2 alimentado pelo Gemini com conhecimento mundial e busca em tempo real. Gere imagens factualmente precisas e deslumbrantes com velocidade ultrarrápida.',
        keywords: 'Nano Banana 2, Google AI, Gemini, geração de imagens, renderização de texto, consistência multi-sujeito, 4K, WeryAI',
        og_title: 'Nano Banana 2 Gerador de Imagens | WeryAI',
        og_description: 'Nano Banana 2 alimentado pelo Gemini com conhecimento mundial e busca em tempo real. Gere imagens factualmente precisas e deslumbrantes com velocidade ultrarrápida.',
        twitter_title: 'Nano Banana 2 Gerador de Imagens | WeryAI',
        twitter_description: 'Nano Banana 2 alimentado pelo Gemini com conhecimento mundial e busca em tempo real. Gere imagens factualmente precisas e deslumbrantes com velocidade ultrarrápida.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        ogImageAlt: 'Gerador de imagens AI Nano Banana 2',
        twitterImageAlt: 'Gerador de imagens AI Nano Banana 2',
    },
    kling_ai: {
        title: 'Kling AI - Gerador de vídeo IA cinematográfico | WeryAI',
        description: 'Experimente Kling AI no WeryAI. Resultados de alta qualidade.',
        keywords: 'Kling AI, vídeo IA, WeryAI',
    },
    runway_ai: {
        title: 'Runway AI - Gerador e editor de vídeo IA | WeryAI',
        description: 'Experimente Runway AI no WeryAI. Resultados de alta qualidade.',
        keywords: 'Runway AI, vídeo IA, WeryAI',
    },
    hailuo_23: {
        title: 'Hailuo 2.3 - Gerador de vídeo IA | WeryAI',
        description: 'Experimente Hailuo 2.3 no WeryAI. Resultados de alta qualidade.',
        keywords: 'Hailuo 2.3, vídeo IA, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI - Gerador de vídeo IA avançado | WeryAI',
        description: 'Experimente Hailuo AI no WeryAI. Resultados de alta qualidade.',
        keywords: 'Hailuo AI, vídeo IA, WeryAI',
    },
    pika_2_2: {
        title: 'Pika 2.2 - Gerador de animação IA | WeryAI',
        description: 'Experimente Pika 2.2 no WeryAI. Resultados de alta qualidade.',
        keywords: 'Pika 2.2, animação IA, WeryAI',
    },
    seedance: {
        title: 'Seedance - Gerador de vídeo de dança e movimento IA | WeryAI',
        description: 'Experimente Seedance no WeryAI. Resultados realistas e profissionais.',
        keywords: 'Seedance, vídeo IA, WeryAI',
    },
    seedance_2: {

        title: 'Werydance 2.0 - Gerador de Vídeo AI de Diretor | WeryAI',

        description: 'Crie vídeos AI de nível diretor com Werydance 2.0: referências multimodais, consistência narrativa e simulação física. Grátis no WeryAI.',

        keywords: 'Werydance 2.0, Seedance AI, weryai, gerador de vídeo AI, vídeo nível diretor, vídeo multimodal, simulação física, sincronização labial, texto para vídeo, vídeo AI grátis, WeryAI',

        og_title: 'Werydance 2.0 - Gerador de Vídeo AI de Diretor | WeryAI',

        og_description: 'Crie vídeos AI de nível diretor com Werydance 2.0: referências multimodais, consistência narrativa e simulação física. Grátis no WeryAI.',

        twitter_title: 'Werydance 2.0 - Gerador de Vídeo AI de Diretor | WeryAI',

        twitter_description: 'Crie vídeos AI de nível diretor com Werydance 2.0: referências multimodais, consistência narrativa e simulação física. Grátis no WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Werydance 2.0 AI Video Generator',

        twitterImageAlt: 'Werydance 2.0 AI Video Generator',

    },
    image_nano_banana_pro: {
        title: 'Grátis Nano Banana Pro - Gerador de Imagens IA | WeryAI',
        description: 'Use Nano Banana Pro no WeryAI para imagens IA de mais alta fidelidade! Rivaliza com Midjourney em qualidade. Créditos grátis, sem cartão.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, Google imagem IA, imagem IA por raciocínio, 4K imagem IA, Nano Banana Pro grátis, como usar Nano Banana Pro, WeryAI',
    },
    image_nano_banana: {
        title: 'Grátis Nano Banana - Gerador de Imagens IA | WeryAI',
        description: 'Use Nano Banana no WeryAI para criar imagens IA facilmente! Modelo IA versátil e rápido para suas necessidades criativas. Créditos grátis, sem cartão.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, Google imagem IA, gerador IA rápido, consistência de personagens, Nano Banana grátis, como usar Nano Banana, WeryAI',
    },
    image_flux: {
        title: 'Grátis FLUX - Experimente o Gerador de Imagens IA | WeryAI',
        description: 'Use FLUX no WeryAI para gerar imagens IA incríveis! Criado pela equipe do Stable Diffusion com qualidade visual excepcional. Créditos grátis, sem cartão.',
        keywords: 'FLUX, FLUX AI, Black Forest Labs, gerador de imagens IA, texto para imagem, arte IA, FLUX grátis, como usar FLUX, WeryAI',
    },
    image_flux_kontext: {
        title: 'Grátis FLUX Kontext - Editor de Imagens IA Pro | WeryAI',
        description: 'Use FLUX Kontext no WeryAI para edição profissional de imagens IA! Aderência superior, tipografia avançada e edição multi-etapas. Créditos grátis, sem cartão.',
        keywords: 'FLUX Kontext, FLUX.1 Kontext, editor de imagens IA, imagens IA profissionais, tipografia IA, FLUX Kontext grátis, como usar FLUX Kontext, WeryAI',
    },
    image_imagen: {
        title: 'Grátis Imagen 4 - Gerador de Imagens IA Google | WeryAI',
        description: 'Use Google Imagen 4 no WeryAI para criar imagens IA fotorrealistas! Controle de estilo versátil e geração de texto precisa. Créditos grátis, sem cartão.',
        keywords: 'Imagen 4, Google Imagen, gerador de imagens IA Google, texto para imagem, IA fotorrealista, Imagen grátis, como usar Imagen 4, WeryAI',
    },
    image_qwen_image: {
        title: 'Grátis Qwen Image - Modelo de Imagens IA Alibaba | WeryAI',
        description: 'Use Qwen Image no WeryAI para gerar arte IA multilíngue! Modelo open-source Alibaba com renderização de texto superior. Créditos grátis, sem cartão.',
        keywords: 'Qwen Image, Alibaba AI, imagem IA open-source, renderização de texto multilíngue, Qwen Image grátis, como usar Qwen Image, WeryAI',
    },
    image_wan_ai: {
        title: 'Grátis Wan AI - Gerador de Imagens Alibaba | WeryAI',
        description: 'Use Wan AI no WeryAI para imagens IA de alta fidelidade! Modelo Alibaba com seguimento preciso de prompts e renderização fotorrealista. Créditos grátis, sem cartão.',
        keywords: 'Wan AI, Wan 2.5, gerador de imagens IA Alibaba, texto para imagem, IA fotorrealista, Wan AI grátis, como usar Wan AI, WeryAI',
    },
    image_seendream: {
        title: 'Grátis Seedream 4.0 - ByteDance Imagem IA | WeryAI',
        description: 'Use Seedream 4.0 no WeryAI para geração ultrarrápida de imagens IA! Modelo ByteDance com estilos artísticos diversificados. Créditos grátis, sem cartão.',
        keywords: 'Seedream, Seedream 4.0, ByteDance imagem IA, imagem IA ultrarrápida, estilos artísticos IA, Seedream grátis, como usar Seedream, WeryAI',
    },
    image_dreamina: {
        title: 'Grátis Dreamina 4.0 - IA de Imagem Multimodal | WeryAI',
        description: 'Use Dreamina 4.0 no WeryAI para criação multimodal de imagens IA! Esboço para imagem, transferência de estilo e fusão de personagens. Créditos grátis, sem cartão.',
        keywords: 'Dreamina 4.0, ByteDance imagem IA, imagem IA multimodal, esboço para imagem, transferência de estilo, Dreamina grátis, como usar Dreamina 4.0, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Grátis Seedream 4.5 - ByteDance Imagem IA | WeryAI',
        description: 'Use Seedream 4.5 no WeryAI para geração de imagens IA principal! Último da ByteDance com tipografia precisa e fusão multi-imagem. Créditos grátis, sem cartão.',
        keywords: 'Seedream 4.5, ByteDance imagem IA, modelo principal, renderização tipográfica, fusão multi-imagem, Seedream 4.5 grátis, como usar Seedream 4.5, WeryAI',
    },
    image_seedream_5_0: {
        title: 'Seedream 5.0 Modelo Definitivo de Geração | WeryAI',
        description: 'Seedream 5.0 é a obra-prima da ByteDance em IA visual com qualidade nativa 8K, compreensão semântica definitiva, composição multi-sujeito e renderização de texto 2.0. Experimente grátis no WeryAI.',
        keywords: 'Seedream 5.0, geração de imagens IA, qualidade 8K, compreensão semântica, composição multi-sujeito, renderização de texto, ByteDance, WeryAI',
        og_title: 'Seedream 5.0 Modelo Definitivo de Geração | WeryAI',
        og_description: 'Seedream 5.0 é a obra-prima da ByteDance em IA visual com qualidade nativa 8K, compreensão semântica definitiva, composição multi-sujeito e renderização de texto 2.0. Experimente grátis no WeryAI.',
        twitter_title: 'Seedream 5.0 Modelo Definitivo de Geração | WeryAI',
        twitter_description: 'Seedream 5.0 é a obra-prima da ByteDance em IA visual com qualidade nativa 8K, compreensão semântica definitiva, composição multi-sujeito e renderização de texto 2.0. Experimente grátis no WeryAI.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        ogImageAlt: 'Gerador de imagens AI Seedream 5.0',
        twitterImageAlt: 'Gerador de imagens AI Seedream 5.0',
    },
    image_recraft_v4_vector: {
        title: 'Recraft V4 Vector - Gerador Profissional de Gráficos Vetoriais IA | WeryAI',
        description: 'Recraft V4 Vector é um gerador profissional de gráficos vetoriais IA da Recraft.ai que gera vetores SVG editáveis com escalamento sem perdas, tipografia precisa e controle de estilo de marca. Experimente grátis no WeryAI agora.',
        keywords: 'Recraft V4 Vector, geração de vetores IA, gerador SVG, vetor verdadeiro, design de logotipo, ícones UI, ilustração vetorial, Recraft, WeryAI',
    },
    image_midjourney: {
        title: 'Grátis Midjourney - Gerador de Arte IA | WeryAI',
        description: 'Use Midjourney no WeryAI para criar imagens IA artísticas! Famoso por estética impressionante e qualidade de iluminação. Créditos grátis, sem cartão.',
        keywords: 'Midjourney, Midjourney AI, gerador de arte IA, imagens IA artísticas, Midjourney grátis, alternativa ao Midjourney, como usar Midjourney, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 Gerador de Vídeo IA | WeryAI',
        description: 'Crie vídeos impressionantes com Runway Gen-4.5 no WeryAI. Arquitetura híbrida autorregressiva-difusão para simulação física precisa e consistência temporal.',
        keywords: 'Runway Gen-4.5, gerador de vídeo IA, vídeo IA cinematográfico, simulação física, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro Gerador de Vídeo IA | WeryAI',
        description: 'Gere vídeos de alta qualidade com Kling 2.6 Pro no WeryAI. Geração audiovisual nativa, qualidade cinematográfica 1080p, excelente aderência a prompts.',
        keywords: 'Kling 2.6 Pro, gerador de vídeo IA, vídeo IA de alta qualidade, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Gerador de Vídeo Controle de câmera | WeryAI',
        description: 'Gere vídeos IA cinematográficos com Dreamina 3.0 (Jimeng 3.0) no WeryAI. Controle preciso de frames início/fim, movimentos de câmera profissionais e geração de vídeo 1080p de alta dinâmica.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, gerador de vídeo IA, controle de câmera, frames início fim, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 Gerador de Vídeo IA Geração de Vídeo | WeryAI',
        description: 'Liberte sua criatividade no WeryAI com o gerador de vídeo IA Kling O1. Perfeito para gerar conteúdo de vídeo imaginativo e único.',
        keywords: 'Kling O1, gerador de vídeo IA, vídeo IA criativo, Kling AI, WeryAI',
    },
    kling_3_0: {

        title: 'Kling 3.0 - Gerador de Vídeo AI Inteligente | WeryAI',

        description: 'Crie vídeos AI com Kling 3.0: storyboard inteligente, sincronização labial multilíngue e renderização de texto precisa. Grátis no WeryAI.',

        keywords: 'Kling 3.0, Kling AI, Kuaishou, gerador de vídeo AI, storyboard inteligente, sincronização labial, renderização de texto, texto para vídeo, imagem para vídeo, vídeo AI grátis, WeryAI',

        og_title: 'Kling 3.0 - Gerador de Vídeo AI Inteligente | WeryAI',

        og_description: 'Crie vídeos AI com Kling 3.0: storyboard inteligente, sincronização labial multilíngue e renderização de texto precisa. Grátis no WeryAI.',

        twitter_title: 'Kling 3.0 - Gerador de Vídeo AI Inteligente | WeryAI',

        twitter_description: 'Crie vídeos AI com Kling 3.0: storyboard inteligente, sincronização labial multilíngue e renderização de texto precisa. Grátis no WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Kling 3.0 AI Video Generator',

        twitterImageAlt: 'Kling 3.0 AI Video Generator',

    },
    vidu_q3: {

        title: 'Vidu Q3 - Gerador Áudio-Vídeo AI Nativo 16s | WeryAI',

        description: 'Gere áudio-vídeo nativo de 16 segundos com Vidu Q3: cortes inteligentes, renderização de texto precisa e lip-sync multilíngue. Grátis no WeryAI.',

        keywords: 'Vidu Q3, Vidu AI, gerador de vídeo AI, áudio-vídeo nativo 16s, storyboard inteligente, renderização de texto, sincronização labial, texto para vídeo, imagem para vídeo, vídeo AI grátis, WeryAI',

        og_title: 'Vidu Q3 - Gerador Áudio-Vídeo AI Nativo 16s | WeryAI',

        og_description: 'Gere áudio-vídeo nativo de 16 segundos com Vidu Q3: cortes inteligentes, renderização de texto precisa e lip-sync multilíngue. Grátis no WeryAI.',

        twitter_title: 'Vidu Q3 - Gerador Áudio-Vídeo AI Nativo 16s | WeryAI',

        twitter_description: 'Gere áudio-vídeo nativo de 16 segundos com Vidu Q3: cortes inteligentes, renderização de texto precisa e lip-sync multilíngue. Grátis no WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Vidu Q3 AI Video Generator',

        twitterImageAlt: 'Vidu Q3 AI Video Generator',

    },
    image_gpt_4o: {
        title: 'Grátis GPT-4o - Gerador de Imagens OpenAI | WeryAI',
        description: 'Use GPT-4o no WeryAI para criar imagens por conversa! IA OpenAI com renderização de texto precisa e resultados de alta fidelidade. Créditos grátis, sem cartão.',
        keywords: 'GPT-4o, GPT-4o imagem, gerador de imagens OpenAI, arte IA conversacional, GPT-4o grátis, como usar GPT-4o imagens, WeryAI',
    },
    image_gpt_image_1_5: {
        title: 'Grátis GPT Image 1.5 - Gerador de Arte OpenAI | WeryAI',
        description: 'Use GPT Image 1.5 no WeryAI para arte IA de nova geração! Último modelo OpenAI com criatividade e detalhes aprimorados. Créditos grátis, sem cartão.',
        keywords: 'GPT Image 1.5, modelo de imagem OpenAI, gerador de arte IA, IA de nova geração, GPT Image 1.5 grátis, como usar GPT Image 1.5, WeryAI',
    },
    heygen_ai: {
        title: 'HeyGen AI Gerador de Vídeo - Plataforma de Apresentador Virtual AI | WeryAI',
        description: 'Experimente o gerador de vídeo HeyGen AI focado em vídeos de apresentador virtual e dublagem multilíngue. Crie conteúdo de vídeo profissional com avatares AI realistas e fala natural. Experimente grátis no WeryAI.',
        keywords: 'HeyGen AI, gerador de vídeo AI, apresentador virtual, dublagem AI, produção de vídeo, vídeo AI grátis, WeryAI',
        og_title: 'HeyGen AI Gerador de Vídeo - Plataforma de Apresentador Virtual AI | WeryAI',
        og_description: 'Crie vídeos profissionais de apresentador virtual com HeyGen AI. Avatares AI realistas, dublagem multilíngue e fala natural. Experimente grátis no WeryAI.',
        twitter_title: 'HeyGen AI Gerador de Vídeo - Plataforma de Apresentador Virtual AI | WeryAI',
        twitter_description: 'Crie vídeos profissionais de apresentador virtual com HeyGen AI. Avatares AI realistas, dublagem multilíngue e fala natural. Experimente grátis no WeryAI.',
    },
    higgsfield_ai: {
        title: 'Higgsfield AI Gerador de Vídeo - Controle Cinematográfico de Câmera | WeryAI',
        description: 'Experimente o gerador de vídeo Higgsfield AI focado em controle cinematográfico de câmera e narrativa visual. Crie conteúdo de vídeo AI com qualidade de diretor e direção de câmera precisa. Experimente grátis no WeryAI.',
        keywords: 'Higgsfield AI, gerador de vídeo AI, vídeo cinematográfico, controle de câmera, produção de vídeo, vídeo AI grátis, WeryAI',
        og_title: 'Higgsfield AI Gerador de Vídeo - Controle Cinematográfico de Câmera | WeryAI',
        og_description: 'Gere vídeos AI cinematográficos com Higgsfield AI. Controle preciso de câmera, narrativa visual e saída com qualidade de diretor. Experimente grátis no WeryAI.',
        twitter_title: 'Higgsfield AI Gerador de Vídeo - Controle Cinematográfico de Câmera | WeryAI',
        twitter_description: 'Gere vídeos AI cinematográficos com Higgsfield AI. Controle preciso de câmera, narrativa visual e saída com qualidade de diretor. Experimente grátis no WeryAI.',
    },
    invideo_ai: {
        title: 'InVideo AI Gerador de Vídeo - Plataforma de Edição Inteligente de Vídeo | WeryAI',
        description: 'Experimente o gerador de vídeo InVideo AI focado em edição inteligente de vídeo e criação automatizada de conteúdo. Crie vídeos de nível profissional através de instruções em linguagem natural. Experimente grátis no WeryAI.',
        keywords: 'InVideo AI, gerador de vídeo AI, edição inteligente de vídeo, criação automatizada, produção de vídeo, vídeo AI grátis, WeryAI',
        og_title: 'InVideo AI Gerador de Vídeo - Edição Inteligente de Vídeo | WeryAI',
        og_description: 'Crie vídeos profissionais com InVideo AI usando instruções em linguagem natural. Edição inteligente e criação automatizada de conteúdo. Experimente grátis no WeryAI.',
        twitter_title: 'InVideo AI Gerador de Vídeo - Edição Inteligente de Vídeo | WeryAI',
        twitter_description: 'Crie vídeos profissionais com InVideo AI usando instruções em linguagem natural. Edição inteligente e criação automatizada de conteúdo. Experimente grátis no WeryAI.',
    },
    luma_dream_machine: {
        title: 'Luma Dream Machine Gerador de Vídeo - Criação de Vídeo Onírico AI | WeryAI',
        description: 'Experimente o gerador de vídeo Luma Dream Machine focado em efeitos visuais oníricos e geração criativa de vídeo. Crie conteúdo de vídeo surreal e imaginativo através de poderosa tecnologia AI. Experimente grátis no WeryAI.',
        keywords: 'Luma Dream Machine, gerador de vídeo AI, vídeo onírico, vídeo criativo, produção de vídeo, vídeo AI grátis, WeryAI',
        og_title: 'Luma Dream Machine Gerador de Vídeo - Vídeo Onírico AI | WeryAI',
        og_description: 'Crie vídeos AI surreais e oníricos com Luma Dream Machine. Efeitos visuais poderosos e geração de conteúdo imaginativo. Experimente grátis no WeryAI.',
        twitter_title: 'Luma Dream Machine Gerador de Vídeo - Vídeo Onírico AI | WeryAI',
        twitter_description: 'Crie vídeos AI surreais e oníricos com Luma Dream Machine. Efeitos visuais poderosos e geração de conteúdo imaginativo. Experimente grátis no WeryAI.',
    },
    leonardo_ai: {
        title: 'Leonardo AI Gerador de Imagens - Direção de Arte para Sistema Visual | WeryAI',
        description: 'Experimente o gerador de imagens Leonardo AI, transforme direção de arte em um sistema visual refinado, crie linguagem visual consistente para personagens, produtos e campanhas. Experimente grátis no WeryAI.',
        keywords: 'Leonardo AI, gerador de imagens AI, arte conceitual, design de personagens, criação de imagens, imagem AI grátis, WeryAI',
        og_title: 'Leonardo AI Gerador de Imagens - Direção de Arte para Sistema Visual | WeryAI',
        og_description: 'Transforme direção de arte em um sistema visual refinado com Leonardo AI. Design consistente de personagens, arte conceitual e visuais de campanha. Experimente grátis no WeryAI.',
        twitter_title: 'Leonardo AI Gerador de Imagens - Direção de Arte para Sistema Visual | WeryAI',
        twitter_description: 'Transforme direção de arte em um sistema visual refinado com Leonardo AI. Design consistente de personagens, arte conceitual e visuais de campanha. Experimente grátis no WeryAI.',
    },
    soulgen_ai: {
        title: 'SoulGen AI Gerador de Imagens - Conceito de Personagem com Perspectiva Distinta | WeryAI',
        description: 'Experimente o gerador de imagens SoulGen AI, dê aos conceitos de personagens um ponto de vista distinto. Crie imagens expressivas a partir de notas de personagens, referências visuais e atmosfera. Experimente grátis no WeryAI.',
        keywords: 'SoulGen AI, gerador de personagens AI, design de personagens, criação de imagens, imagem AI grátis, WeryAI',
        og_title: 'SoulGen AI Gerador de Imagens - Criação de Conceito de Personagem | WeryAI',
        og_description: 'Dê aos conceitos de personagens uma voz visual distinta com SoulGen AI. Crie imagens expressivas a partir de personalidade, referências e atmosfera. Experimente grátis no WeryAI.',
        twitter_title: 'SoulGen AI Gerador de Imagens - Criação de Conceito de Personagem | WeryAI',
        twitter_description: 'Dê aos conceitos de personagens uma voz visual distinta com SoulGen AI. Crie imagens expressivas a partir de personalidade, referências e atmosfera. Experimente grátis no WeryAI.',
    },
    stable_diffusion: {
        title: 'Stable Diffusion Gerador de Imagens - Arte AI Open Source | WeryAI',
        description: 'Experimente o gerador de imagens Stable Diffusion, uma ferramenta de geração de imagens AI open-source e poderosa. Crie obras de arte AI únicas através de controle flexível e estilos diversos. Experimente grátis no WeryAI.',
        keywords: 'Stable Diffusion, gerador de imagens AI, AI open source, geração de imagens, arte AI, imagens AI grátis, WeryAI',
        og_title: 'Stable Diffusion Gerador de Imagens - Arte AI Open Source | WeryAI',
        og_description: 'Crie obras de arte AI únicas com controles flexíveis e estilos diversos do Stable Diffusion. Open-source e poderoso. Experimente grátis no WeryAI.',
        twitter_title: 'Stable Diffusion Gerador de Imagens - Arte AI Open Source | WeryAI',
        twitter_description: 'Crie obras de arte AI únicas com controles flexíveis e estilos diversos do Stable Diffusion. Open-source e poderoso. Experimente grátis no WeryAI.',
    },
}
